import script from "./StorageCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageCounter.vue?vue&type=script&setup=true&lang=js"

import "./StorageCounter.vue?vue&type=style&index=0&id=4e0edd2d&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0edd2d"]])

export default __exports__